import {PartialDeep} from "type-fest";

export type ControlConfig = {
    start: HTMLButtonElement,
    stop: HTMLButtonElement,
    playback: HTMLDivElement,
    clock: HTMLDivElement,
}

export type CookieConfig = {
    enabled: boolean,
    name: string,
}

export type PlayerConfig = {
    ui: HTMLDivElement
}

export type Config = {
    timeLimit: number,
    controls: ControlConfig
    cookie: CookieConfig
    player: PlayerConfig
    apiBaseUrl: string

}

export const DefaultConfig : PartialDeep<Config>  = {
    timeLimit: 60,
    cookie: {
        name: "webyarns-recording-id"
    },
    apiBaseUrl: "./api"
}